import {
  ZERO_AS_FREE,
  ZERO_AS_HIDDEN,
  ZERO_AS_INCLUDED,
} from '../../constants';

const getFormatPriceByNKBF = (cost, zeroDisplayNum, costText) => {
  if (parseFloat(cost ?? '0') !== 0) {
    return costText;
  }
  let priceDisplay = '';
  switch (zeroDisplayNum) {
    case ZERO_AS_HIDDEN:
      priceDisplay = null;
      break;
    case ZERO_AS_FREE:
      priceDisplay = 'Free';
      break;
    case ZERO_AS_INCLUDED:
      priceDisplay = 'Included';
      break;
    default:
      priceDisplay = costText;
      break;
  }
  return priceDisplay;
};
export default getFormatPriceByNKBF;
